import { connect } from 'react-redux';
import LoadMore from '../../../components/common/LoadMore';
import { loadNextSlip } from '../actions';
import { isLoadingMoreSlips } from '../selectors';

const mapStateToProps = state => ({
  showSpinner: isLoadingMoreSlips(state)
});

const mapDispatchToProps = {
  onClick: loadNextSlip
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadMore);
